/**
 * Universal links → in-app routes.
 *
 * iOS hands the store app the full link it was opened with (a lead email's
 * button, a WhatsApp message). Only our own domain is honoured, and only the
 * path + query travel into the router — never the host, never a stray
 * scheme. Anything else returns null and is ignored.
 */
export const APP_HOSTS = new Set(["www.phiegcrm.com", "phiegcrm.com"]);

export function universalLinkToPath(url) {
  if (typeof url !== "string" || !url) return null;
  let parsed;
  try {
    parsed = new URL(url);
  } catch {
    return null;
  }
  if (parsed.protocol !== "https:" || !APP_HOSTS.has(parsed.hostname)) return null;
  const path = parsed.pathname || "/";
  if (!path.startsWith("/")) return null;
  return `${path}${parsed.search || ""}`;
}
